import React from 'react';
import styled, { keyframes } from 'styled-components';

function Loading({isOpen, title}) {
    if(!isOpen){
        return null;
    }
  return (
    <ModalWrapper>
        <Content>
            <Title>{title}</Title>
            <Spinner />
        </Content>
    </ModalWrapper>
  );
}

// 키 프레임 애니메이션 정의
const spinAnimation = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

// 모달을 위한 스타일드 컴포넌트
const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 0;
  padding: 24px;
`;

const Title = styled.div`
    text-align: center;
    font-size: 20px;
`

const Content = styled.div`
    width: 500px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: white;
    padding: 30px;
    border-radius: 20px;
    gap: 20px;
`

const Spinner = styled.div`
  border: 5px solid #f3f3f3; /* Light grey */
  border-top: 5px solid #3366FF;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation-name: slideUp;
  animation-duration: 1s;
  animation: ${spinAnimation} 2s linear infinite;
`;

export default Loading;